import React, { useEffect, useState, useRef } from "react";
import { message, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getUserClaims } from "../../utils/auth/unified-auth";
import { useAuth } from "../../utils/auth/useAuth";
import { useLocation, useSearchParams, useNavigationType } from "react-router-dom";
import { LoadingSpinner, Card, Switcher, DateRangePicker, AdvancedPagination, EmptyStateV2, Icon } from "pepsico-ds";
import MultiSelectDropdown from '../../components/Dropdown/MultiSelectDropdown';
import { getCategoriesL0ForSupplierFilters, getCategoriesL1ForSupplierFilters, getCategoriesL2ForSupplierFilters } from "../KPIOverview/KpiUtils";
import { formatIntoDropdownData, getOverlappingOptionsV2, getMonthsAdjustedForCurrentDate, getCurrentMonthObject ,getToDateOptions, getMonthsWithYearWithMaxDate, getToDateOptionsWithMaxDate, getMonthsWithYearRangeAdjustedForMaxDate, getOverlappingOptions, returnHyphenIfNull, transformIndexData, getAdditionalDisplayTexts, getFirstUniqueItems, call7DaysNpsLogic } from '../../utils/utils';
import CommodityPageHeader from "../../components/Header/CommodityPageHeader";
import { useToast } from '../../components/Toast/ToastContext';
import NewsBanner from '../../assets/NewsBanner.svg'
import reset_icon from "../../assets/reset_icon.svg";
import Vector from '../../assets/Vector.png'
import NewsCard from "../../components/Cards/NewsCard";
import ShareNewsModal from "../../components/Cards/ShareNewsModal";
import SectorDefinitionsModal from "../../components/Modal/SectorDefinitionsModal";
import { FetchLandingPageAction } from "../../redux/action/LandingPageAction";
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import { localStoreKeys } from '../../constants/localStoreKeys';
import { FetchAllNewsListActionV2, FetchBookmarkListAction, FetchNewsDropdownDataAction, FetchRISIDropdownAction, FetchRISISecondaryDropdownAction, UpdateBookmarkAction } from "../../redux/action/RISIAction";
import NoData from "../../components/NoData/NoData";
import { usePrevRoute } from "./RouteContext";
import { useLoginEffects } from "../WalkmeTour/UseLoginEffects";


const NEWS_SOURCE_OPTIONS = [
    { id: 1, displayText: "FastMarkets RISI" },
    { id: 2, displayText: "SmartCube" }
]


  


function NewsOverview() {    
    const { authState, authInstance } = useAuth();
    const navType = useNavigationType();
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const location = useLocation();
    const { state } = location;
    const currentFilters = state?.currentFilters ?? {};
    const loadPreviousSelection = state?.loadPreviousSelection ?? false;
    const [checkPreviousSelection, setCheckPreviousSelection] = useState(loadPreviousSelection)
	const dispatch = useDispatch();
    const [switcherIndex, setSwitcherIndex] = useState(0)
    const [allListCurrentPage, setAllListCurrentPage] = useState(1);
    const [bookmarkListCurrentPage, setBookmarkListCurrentPage] = useState(1);
    const [allNewsPageCount, setAllNewsPageCount] = useState(15);
    const [bookmarkedNewsPageCount, setBookmarkedNewsPageCount] = useState(10);
	const [userEmailId, setUserEmailId] = useState({});
	const [userInfo, setUserInfo] = useState({});
	const userInfoRef = useRef({});
	const isUserDataFetchedRef = useRef(false);
	// true only while dateRange is being set programmatically (e.g. filters reset), consumed by onDateChange
	const isProgrammaticDateChangeRef = useRef(false);
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [totalBookmarkCount, setTotalBookmarkCount] = useState(0);
    const [currentBookmarkPageRows, setCurrentBookmarkPageRows] = useState([]);
    const [allBookmarkedArticles, setAllBookmarkedArticles] = useState([]);
    const [currentFiltersSaved, setCurrentFiltersSaved] = useState({})
    const [shareModalNewsItem, setShareModalNewsItem] = useState(null);
    const [showShareModal, setShowShareModal] = useState(false);
    const [showSmartCubeDetailsModal, setShowSmartCubeDetailsModal] = useState(false);

    const [dropdownValues, setDropdownValues] = useState({})
    const [newsSourceSelected, setNewsSourceSelected] = useState(NEWS_SOURCE_OPTIONS)
    const [sectors, setSectors] = useState([])
    const [sectorSelected, setSectorSelected] = useState([])
    const [isUserDataFetched, setIsUserDataFetched] = useState(false)
    const [categoryL0Options, setCategoryL0Options] = useState([])
    const [categoryL0Selected, setCategoryL0Selected] = useState([])
    const [categoryL1Options, setCategoryL1Options] = useState([])
    const [categoryL1Selected, setCategoryL1Selected] = useState([])
    const [categoryL2Options, setCategoryL2Options] = useState([])
    const [categoryL2Selected, setCategoryL2Selected] = useState([])
    
    const [datePickerMenu, setDatePickerMenu] = useState({});
    const [dateRange, setDateRange] = useState({})
    const [minYear, setMinYear] = useState(2023);
    const [maxYear, setMaxYear] = useState(2024);

	const userData = useSelector((state) => state.getLandingPageReducer);
	const newsDropdownData = useSelector((state) => state.getNewsDropdownDataReducer);
	const allNewsData = useSelector((state) => state.getAllNewsListReducer);
	const bookmarkListData = useSelector((state) => state.getBookmarkListReducer);
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
	const bookmarkSaveData = useSelector((state) => state.getUpdateBookmarkReducer);
    
    const { showToast } = useToast();
    // const shouldRestore = searchParams.get('restore') === '1' || (navType === 'POP') //  && location.state?.filters);
    // console.log(searchParams.get('restore') === '1', (navType === 'POP'))
	const prevRoute = usePrevRoute();

    useLoginEffects(userData)
    
	/* istanbul ignore next */
    useEffect(() => {
		async function fetchUserInfo() {
			const user = await getUserClaims();
			if (user) {
				userInfoRef.current = user;
				setUserInfo(user);
				dispatch(FetchLandingPageAction(user));
				isUserDataFetchedRef.current = true;
				setIsUserDataFetched(true)
				setIsFirstLoad(true);
			}
		}
        setIsDataLoading(true)
		fetchUserInfo();
	}, []);

	/* istanbul ignore next */
    useEffect(() => {
        return () => {
            dispatch({ 
                type: 'RESET_NEWS_DROPDOWN_DATA_ACTION', 
                payload: "RESET_NEWS_DROPDOWN_DATA_ACTION" 
            });
            dispatch({ 
                type: 'RESET_ALL_NEWS_LIST_ACTION', 
                payload: "RESET_ALL_NEWS_LIST_ACTION" 
            });
            dispatch({ 
                type: 'RESET_UPDATE_BOOKMARK_ACTION', 
                payload: "RESET_UPDATE_BOOKMARK_ACTION" 
            });
            dispatch({ 
                type: 'RESET_BOOKMARK_LIST_ACTION', 
                payload: "RESET_BOOKMARK_LIST_ACTION" 
            });
            
        };
    }, []);

    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && userData && userData.type === "SUCCESS_LANDING_PAGE_ACTION") {

            call7DaysNpsLogic(dispatch, userData)

            const currentFilters = JSON.parse(localStorage.getItem("newsfilters_ph"))
            let newsSourceSelectedVal = NEWS_SOURCE_OPTIONS;
            if(verifyPreviousRoute(prevRoute) && currentFilters?.newsSourceData && currentFilters?.newsSourceData?.length>0 && isFirstLoad) {
                newsSourceSelectedVal = currentFilters?.newsSourceData
            }
            setNewsSourceSelected(newsSourceSelectedVal);
            localStorage.setItem('newsSourceSelected_risi', JSON.stringify(newsSourceSelectedVal));

            setIsDataLoading(true)
            const sourceStrings = newsSourceSelectedVal?.map((item) => item.displayText ? item.displayText : item);
            dispatch(FetchNewsDropdownDataAction({ source: sourceStrings }));
        }
		
    }, [userData])

	/* istanbul ignore next */
    const verifyPreviousRoute = (route) => {
        return route?.includes("/overview/news/news-detail/")
    }

	/* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && newsDropdownData && newsDropdownData.type === "SUCCESS_NEWS_DROPDOWN_DATA_ACTION") {
            const dropdownResponse = newsDropdownData;
            const rawDropdownData = dropdownResponse?.dropdownData;
            setDropdownValues(rawDropdownData);

            const currentFilters = JSON.parse(localStorage.getItem("newsfilters_ph"))

            const sectorList = rawDropdownData?.sector?.map((item, index) => ({ displayText: item, id: index + 1 })) || [];
            setSectors(sectorList);
            let sectorSelectedVal = sectorList;
            if(verifyPreviousRoute(prevRoute) && currentFilters?.sectorsData && currentFilters?.sectorsData?.length>0 && isFirstLoad) {
                sectorSelectedVal = currentFilters?.sectorsData
            }
            setSectorSelected(sectorSelectedVal);
            localStorage.setItem('sectorsSelected_risi', JSON.stringify(sectorSelectedVal));

            const l0Options = getCategoriesL0ForSupplierFilters(rawDropdownData?.l0);
            setCategoryL0Options(l0Options);
            let l0SelectedVal = l0Options;
            if(verifyPreviousRoute(prevRoute) && currentFilters?.categoryL0Data && currentFilters?.categoryL0Data?.length>0 && isFirstLoad) {
                l0SelectedVal = currentFilters?.categoryL0Data
            }
            setCategoryL0Selected(l0SelectedVal);
            localStorage.setItem('categoryL0Selected_risi', JSON.stringify(l0SelectedVal));

            let categoriesL0ToInclude = l0SelectedVal?.map((item) => (item.displayText ? item.displayText : item));
            const l1Options = getCategoriesL1ForSupplierFilters(rawDropdownData?.l0, categoriesL0ToInclude);
            setCategoryL1Options(l1Options);
            let l1SelectedVal = l1Options;
            if(verifyPreviousRoute(prevRoute) && currentFilters?.categoryL1Data && currentFilters?.categoryL1Data?.length>0 && isFirstLoad) {
                l1SelectedVal = currentFilters?.categoryL1Data
            }
            setCategoryL1Selected(l1SelectedVal);
            localStorage.setItem('categoryL1Selected_risi', JSON.stringify(l1SelectedVal));

            let categoriesL1ToInclude = l1SelectedVal?.map((item) => (item.displayText ? item.displayText : item));
            const l2Options = getCategoriesL2ForSupplierFilters(rawDropdownData?.l0, categoriesL0ToInclude, categoriesL1ToInclude);
            setCategoryL2Options(l2Options);
            let l2SelectedVal = l2Options;
            if(verifyPreviousRoute(prevRoute) && currentFilters?.categoryL2Data && currentFilters?.categoryL2Data?.length>0 && isFirstLoad) {
                l2SelectedVal = currentFilters?.categoryL2Data
            }
            setCategoryL2Selected(l2SelectedVal);
            localStorage.setItem('categoryL2Selected_risi', JSON.stringify(l2SelectedVal));

            const minDate = new Date(dropdownResponse?.dateRange?.minDate);
            minDate.setDate(minDate.getDate() - 1);
            setMinYear(minDate?.getUTCFullYear())
            setMaxYear(new Date(dropdownResponse?.dateRange?.maxDate)?.getUTCFullYear())

            setDatePickerMenu({
                disabled: {
                  beforeDate: minDate,
                  afterDate: (new Date(dropdownResponse?.dateRange?.maxDate)),
                  weekends: false,
                },
            });
            let dateRangeSelected = 
            { 
                from: new Date(dropdownResponse?.dateRange?.fromDate),
                to: new Date(dropdownResponse?.dateRange?.maxDate)
            }
            if(verifyPreviousRoute(prevRoute) && currentFilters?.dateRangeData && currentFilters?.dateRangeData?.from && currentFilters?.dateRangeData?.to && isFirstLoad) {
                dateRangeSelected = 
                    { 
                        from: new Date(currentFilters?.dateRangeData?.from),
                        to: new Date(currentFilters?.dateRangeData?.to)
                    }
            }
            isProgrammaticDateChangeRef.current = true;
            setDateRange(dateRangeSelected)
            
            localStorage.setItem('dateRangeSelected_risi', JSON.stringify(dateRangeSelected));
            dispatch(setKeyValue({ key: localStoreKeys.maxAllowedBookmarks, value: dropdownResponse?.totalBookmarksAllowed }))
            
            let currentSwitcherIndex = 0;
            if(verifyPreviousRoute(prevRoute)) {
                currentSwitcherIndex = currentFilters?.currentTab || 0;
                if(currentSwitcherIndex===0) { // All News Page
                    setAllListCurrentPage(currentFilters?.pageNumber || 1);
                    localStorage.setItem('ph_all_current_page', currentFilters?.pageNumber || 1);
                    setBookmarkListCurrentPage(1);
                    localStorage.setItem('ph_bookmark_current_page', 1);

                } else { // Bookmarks Page

                    setAllListCurrentPage(1);
                    localStorage.setItem('ph_all_current_page', 1);
                    setBookmarkListCurrentPage(1);
                    localStorage.setItem('ph_bookmark_current_page',1);
                }
            } else {
            
                setAllListCurrentPage(1);
                localStorage.setItem('ph_all_current_page', 1);
                setBookmarkListCurrentPage(1);
                localStorage.setItem('ph_bookmark_current_page',1);
            }
            localStorage.removeItem("newsfilters_ph")
            setSwitcherIndex(currentSwitcherIndex)
            localStorage.setItem('ph_news_current_switch', currentSwitcherIndex);

            if(currentSwitcherIndex===0) {
                loadKPIPageData()
            } else if(currentSwitcherIndex===1) {
                loadbookmarkPageData();
            }
        }
    }, [newsDropdownData])

     /* istanbul ignore next */
     useEffect(() => {
        if (isUserDataFetched && bookmarkSaveData && bookmarkSaveData.type === "SUCCESS_UPDATE_BOOKMARK_ACTION") {
            setTotalBookmarkCount(bookmarkSaveData?.totalBookMark)
            dispatch(setKeyValue({ key: localStoreKeys.newsArticleBookmarkCount, value: bookmarkSaveData?.totalBookMark }))
            
            // showToast('success', "Bookmark Saved Successfully", {
            //     icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
            // });
        }
    }, [bookmarkSaveData])
    
    /* istanbul ignore next */
    useEffect(() => {
        if (allNewsData && allNewsData.type === "SUCCESS_ALL_NEWS_LIST_ACTION") {
            setIsDataLoading(false);
            setAllNewsPageCount(allNewsData?.totalPages)
            setTotalBookmarkCount(allNewsData?.totalBookMark)
            setCheckPreviousSelection(false);
            dispatch(setKeyValue({ key: localStoreKeys.newsArticleBookmarkCount, value: allNewsData?.totalBookMark }))
            setIsFirstLoad(false);
        }
    }, [allNewsData])
    
    /* istanbul ignore next */
    useEffect(() => {
        if (bookmarkListData && bookmarkListData.type === "SUCCESS_BOOKMARK_LIST_ACTION") {
            setIsDataLoading(false);
            setTotalBookmarkCount(bookmarkListData?.totalBookMark)
            setBookmarkedNewsPageCount(getTotalPages(bookmarkListData?.newsContent))
            const currentPageRecords = getPageRecords(bookmarkListData?.newsContent, 1);
            setCurrentBookmarkPageRows(currentPageRecords);
            setAllBookmarkedArticles(bookmarkListData?.newsContent);
            dispatch(setKeyValue({ key: localStoreKeys.newsArticleBookmarkCount, value: bookmarkListData?.totalBookMark }))
            setIsFirstLoad(false);
        }
    }, [bookmarkListData])

    

    
    /* istanbul ignore next */
    const onNewsSourceChange = (val) => {
        if (val && val.length > 0) {

            resetPagination();
            setNewsSourceSelected(val)
            localStorage.setItem("newsSourceSelected_risi", JSON.stringify(val))

            setIsDataLoading(true);
            const sourceStrings = val?.map(item => (item.displayText ? item.displayText : item));
            dispatch(FetchNewsDropdownDataAction({ source: sourceStrings }));
        } else {
            
            if (val && val.length === 0) {
                setNewsSourceSelected([])
                localStorage.setItem("newsSourceSelected_risi", JSON.stringify([]))
                message.warning("At least one news source is required")
            }

        }
    }
    /* istanbul ignore next */
    const onSectorChange = (val) => {
        if (val && val.length > 0) {

            resetPagination();
            setSectorSelected(val)
            localStorage.setItem("sectorsSelected_risi", JSON.stringify(val))
            loadKPIPageData();
        } else {
            
            if (val && val.length === 0) {
                setSectorSelected([])
                localStorage.setItem("sectorsSelected_risi", JSON.stringify([]))
                message.warning("At least one sector is required")
            }

        }
    }

    /* istanbul ignore next */
    const onCategoryL0Change = (val) => {
        if (val && val.length > 0) {
        
            resetPagination();
            setCategoryL0Selected(val);
            localStorage.setItem('categoryL0Selected_risi', JSON.stringify(val));

            let categoriesL0ToInclude = val?.map(item => (item.displayText ? item.displayText : item));
            const l1Options = getCategoriesL1ForSupplierFilters(dropdownValues?.l0, categoriesL0ToInclude);
            setCategoryL1Options(l1Options);
            setCategoryL1Selected(l1Options);
            localStorage.setItem('categoryL1Selected_risi', JSON.stringify(l1Options));

            let categoriesL1ToInclude = l1Options?.map(item => (item.displayText));
            const l2Options = getCategoriesL2ForSupplierFilters(dropdownValues?.l0, categoriesL0ToInclude, categoriesL1ToInclude);
            setCategoryL2Options(l2Options);
            setCategoryL2Selected(l2Options);
            localStorage.setItem('categoryL2Selected_risi', JSON.stringify(l2Options));

            loadKPIPageData();
        }
        else {
            
            if (val && val.length === 0) {
                setCategoryL2Options([]);
                setCategoryL2Selected([]);
                localStorage.setItem('categoryL2Selected_risi', JSON.stringify([]));
                setCategoryL1Options([]);
                setCategoryL1Selected([]);
                localStorage.setItem('categoryL1Selected_risi', JSON.stringify([]));
                setCategoryL0Selected([]);
                localStorage.setItem('categoryL0Selected_risi', JSON.stringify([]));
                message.warning("At least one category L0 is required")
            }
        }
    }
    /* istanbul ignore next */
    const onCategoryL1Change = (val) => {
        if (val && val.length > 0) {
        
            resetPagination();
            setCategoryL1Selected(val)
            localStorage.setItem("categoryL1Selected_risi", JSON.stringify(val))

            let categoriesL0ToInclude = categoryL0Selected?.map(item => (item.displayText ? item.displayText : item));
            let categoriesL1ToInclude = val?.map(item => (item.displayText ? item.displayText : item));
            const l2Options = getCategoriesL2ForSupplierFilters(dropdownValues?.l0, categoriesL0ToInclude, categoriesL1ToInclude);
            setCategoryL2Options(l2Options);
            setCategoryL2Selected(l2Options);
            localStorage.setItem('categoryL2Selected_risi', JSON.stringify(l2Options));

            loadKPIPageData();
        }
        else {
            
            if (val && val.length === 0) {
                setCategoryL2Options([]);
                setCategoryL2Selected([]);
                localStorage.setItem('categoryL2Selected_risi', JSON.stringify([]));
                setCategoryL1Selected([]);
                localStorage.setItem('categoryL1Selected_risi', JSON.stringify([]));
                message.warning("At least one category L1 is required")
            }
        }
    }
    /* istanbul ignore next */
    const onCategoryL2Change = (val) => {
        if (val && val.length > 0) {
        
            resetPagination();
            setCategoryL2Selected(val)
            localStorage.setItem("categoryL2Selected_risi", JSON.stringify(val))
            loadKPIPageData();
        }
        else {
            
            if (val && val.length === 0) {
                setCategoryL2Selected([]);
                localStorage.setItem('categoryL2Selected_risi', JSON.stringify([]));
                message.warning("At least one category L2 is required")
            }
        }
    }
	/* istanbul ignore next */
    const getUTCDate = (d) => {
        return new Date(Date.UTC(
            d.getFullYear(),
            d.getMonth(),
            d.getDate()
          ))?.toISOString();
    }


	/* istanbul ignore next */
    const resetPagination = () => {
        
        setAllListCurrentPage(1);
        localStorage.setItem('ph_all_current_page', 1);
        setBookmarkListCurrentPage(1);
        localStorage.setItem('ph_bookmark_current_page', 1);
    }

	/* istanbul ignore next */
    const onDateChange = (val)=> {
        if(isProgrammaticDateChangeRef.current) {
            isProgrammaticDateChangeRef.current = false;
            return;
        }
        
        resetPagination();

        const from = new Date(val?.from);
        const to = new Date(val?.to);
        const fromStr = val?.from ? getUTCDate(from):null
        const toStr = val?.to ?getUTCDate(to):null
        const dateData = {from:fromStr, to:toStr}

        setDateRange(val);
        localStorage.setItem('dateRangeSelected_risi', JSON.stringify(dateData));
        loadKPIPageData();
    }

    /* istanbul ignore next */
    const onFiltersReset = () => {
        
        localStorage.removeItem("newsfilters_ph")

        setNewsSourceSelected(NEWS_SOURCE_OPTIONS);
        localStorage.setItem('newsSourceSelected_risi', JSON.stringify(NEWS_SOURCE_OPTIONS));

        resetPagination();
        setIsDataLoading(true);
        const sourceStrings = NEWS_SOURCE_OPTIONS?.map(item => item.displayText);
        dispatch(FetchNewsDropdownDataAction({ source: sourceStrings }));

    }

	/* istanbul ignore next */
    function getTotalPages(data, rowsPerPage = 10) {
        if (!Array.isArray(data)) return 0;
        if (!Number.isInteger(rowsPerPage) || rowsPerPage <= 0) return 0;
        if (data.length === 0) return 0;
        return Math.ceil(data?.length / rowsPerPage);
    }
	/* istanbul ignore next */
    function getPageRecords(data, currentPage, rowsPerPage = 10) {
        if (!Array.isArray(data)) return [];
        if (!Number.isInteger(rowsPerPage) || rowsPerPage <= 0) return [];
        if (!Number.isInteger(currentPage)) return [];
      
        const totalPages = getTotalPages(data, rowsPerPage);
        if (totalPages === 0) return [];
        if (currentPage < 1 || currentPage > totalPages) return [];
      
        const start = (currentPage - 1) * rowsPerPage;
        const end = start + rowsPerPage;
        return data.slice(start, end);
    }

	/* istanbul ignore next */
    const onAllPageChange = (val) => {
        setAllListCurrentPage(val);
        localStorage.setItem('ph_all_current_page', val);
        loadKPIPageData();
        
    } 
	/* istanbul ignore next */
    const onBookmarkPageChange = (val) => {
        setBookmarkListCurrentPage(val);
        localStorage.setItem('ph_bookmark_current_page', val);
        const filters ={
            ...currentFiltersSaved,
            bookmarkPageNumber: Number(val)
        }
        setCurrentFiltersSaved(filters)
        const currentRecords = getPageRecords(allBookmarkedArticles, val)
        setCurrentBookmarkPageRows(currentRecords);
    } 

	/* istanbul ignore next */
    const switchTabs = (val) => {
        if (!isUserDataFetchedRef.current) {
            return;
        }

        setSwitcherIndex(val)
        localStorage.setItem('ph_news_current_switch', val);
        setAllListCurrentPage(1);
        localStorage.setItem('ph_all_current_page', 1);
        setBookmarkListCurrentPage(1);
        localStorage.setItem('ph_bookmark_current_page', 1);
        if(val===0) {
            loadKPIPageData()
        } else if(val===1) {
            loadbookmarkPageData();
        }

    }
	/* istanbul ignore next */
    const loadKPIPageData = () => {
        
        const newsSourceData = JSON.parse(localStorage.getItem("newsSourceSelected_risi"));
        const sectorsData = JSON.parse(localStorage.getItem("sectorsSelected_risi"));
        const categoryL0Data = JSON.parse(localStorage.getItem("categoryL0Selected_risi"));
        const categoryL1Data = JSON.parse(localStorage.getItem("categoryL1Selected_risi"));
        const categoryL2Data = JSON.parse(localStorage.getItem("categoryL2Selected_risi"));
        const dateRangeData = JSON.parse(localStorage.getItem("dateRangeSelected_risi"));
        const fromDate = dateRangeData?.from || null;
        const toDate = dateRangeData?.to || null;
 
        const filters = {
            newsSourceData: newsSourceData,
            sectorsData: sectorsData,
            categoryL0Data: categoryL0Data,
            categoryL1Data: categoryL1Data,
            categoryL2Data: categoryL2Data,
            dateRangeData: dateRangeData,
            currentTab: Number(localStorage.getItem('ph_news_current_switch')),
            pageNumber: Number(localStorage.getItem('ph_all_current_page')), 
            bookmarkPageNumber: Number(localStorage.getItem('ph_bookmark_current_page'))
        }
 
        setCurrentFiltersSaved(filters)
        localStorage.setItem("newsfilters_ph",JSON.stringify(filters));

        if(newsSourceData?.length>0 &&
            sectorsData?.length>0 &&
            categoryL0Data?.length>0 &&
            categoryL1Data?.length>0 &&
            categoryL2Data?.length>0 &&
            fromDate &&
            toDate
        ) {
            const requestObject = {
                emailId: userInfoRef.current?.email || '',
                pageNumber: Number(localStorage.getItem('ph_all_current_page'))-1,
                fromDate: fromDate || '',
                toDate: toDate || '',
                newsSource: newsSourceData?.map((item) => item.displayText ? item.displayText : item),
                sector: sectorsData?.map((item) => item.displayText ? item.displayText : item),
                l0: categoryL0Data?.map((item) => item.displayText),
                l1: categoryL1Data?.map((item) => item.displayText),
                l2: categoryL2Data?.map((item) => item.displayText),
            };
            
            setIsDataLoading(true);
            dispatch(FetchAllNewsListActionV2(requestObject));

        } else {
            message.warning("Please select required filters");
        }
        

    }

	/* istanbul ignore next */
    const loadbookmarkPageData = () => {
        const newsSourceData = JSON.parse(localStorage.getItem("newsSourceSelected_risi"));
        const sectorsData = JSON.parse(localStorage.getItem("sectorsSelected_risi"));  
        const categoryL0Data = JSON.parse(localStorage.getItem("categoryL0Selected_risi"));
        const categoryL1Data = JSON.parse(localStorage.getItem("categoryL1Selected_risi"));
        const categoryL2Data = JSON.parse(localStorage.getItem("categoryL2Selected_risi"));
        const dateRangeData = JSON.parse(localStorage.getItem("dateRangeSelected_risi"));

        const filters = {
            newsSourceData: newsSourceData,
            sectorsData: sectorsData,
            categoryL0Data: categoryL0Data,
            categoryL1Data: categoryL1Data,
            categoryL2Data: categoryL2Data,
            dateRangeData: dateRangeData,
            currentTab: Number(localStorage.getItem('ph_news_current_switch')),
            pageNumber: Number(localStorage.getItem('ph_all_current_page')),
            bookmarkPageNumber: Number(localStorage.getItem('ph_bookmark_current_page'))
        }
        setCurrentFiltersSaved(filters)
        localStorage.setItem("newsfilters_ph",JSON.stringify(filters));
        setIsDataLoading(true)
        dispatch(FetchBookmarkListAction(userInfoRef.current?.email || ''));
    }

	/* istanbul ignore next */
    const bookmarkNews = (news) => {
        const requestObject = {
            emailId: userInfoRef.current?.email || '',
            newsId: news?.id || '',
            type: news?.isBookmarked?"SAVE":"DELETE"
        };
        
        const updatedList = allBookmarkedArticles?.map(item => 
            item.id === news?.id 
                ? { ...item, isBookmarked: news?.isBookmarked }
                : item
        );
        setAllBookmarkedArticles(updatedList)
        dispatch(UpdateBookmarkAction(requestObject));
    }

	/* istanbul ignore next */
    const shareNews = (news) => {
        setShareModalNewsItem(news);
        setShowShareModal(true);
    }

	
	/* istanbul ignore next */
	if(authState?.isAuthenticated){
		return(
			
                <>
                    <CommodityPageHeader header={"News & Trends"}
                        subtext={"<span>Stay ahead of the market with the latest commodity news, and industry trends — all from trusted global sources.</span>"}
                        image={NewsBanner}
                        refreshFrequency={allNewsData?.refreshFrequency || "-"}
                        lastUpdated={allNewsData?.lastUpdated || "-"}
                    />
                    <Row gutter={[10, 10]} justify="start" style={{ width: "100%", marginTop:"24px" }}>
                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                            <MultiSelectDropdown placeholder="News Source" className='buy-con-dropdown-modal' label="News Source" childList={NEWS_SOURCE_OPTIONS} selectedValue={newsSourceSelected} setSelectedValue={onNewsSourceChange} />
                        </Col>
                    </Row>
                    <Row gutter={[10, 10]} justify="start" style={{ width: "100%", marginTop:"12px" }}>
                        
                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                            <div className="buy-con-dropdown-label" style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                Sector
                                <span
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            setShowSmartCubeDetailsModal(true);
                                        }
                                    }}
                                    onClick={() => {
                                        setShowSmartCubeDetailsModal(true)
                                    }
                                }>
                                    <Icon alt="" icon="info" size="small"/>
                                </span>
                            </div>
                            <MultiSelectDropdown placeholder="Sectors" className='buy-con-dropdown-modal' childList={sectors} selectedValue={sectorSelected} setSelectedValue={onSectorChange} />
                        </Col>
                        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                            <MultiSelectDropdown placeholder="Categories L0" className='buy-con-dropdown-modal' label="Category L0" childList={categoryL0Options} selectedValue={categoryL0Selected} setSelectedValue={onCategoryL0Change} />
                        </Col>
                        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                            <MultiSelectDropdown placeholder="Categories L1" className='buy-con-dropdown-modal' label="Category L1" childList={categoryL1Options} selectedValue={categoryL1Selected} setSelectedValue={onCategoryL1Change} />
                        </Col>
                        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                            <MultiSelectDropdown placeholder="Categories L2" className='buy-con-dropdown-modal' label="Category L2" childList={categoryL2Options} selectedValue={categoryL2Selected} setSelectedValue={onCategoryL2Change} />
                        </Col>
                        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                            <>
                                <div className='buy-con-dropdown-label' title={"Date Range (MM/DD/YYYY)"}>{"Date Range (MM/DD/YYYY)"}</div>
                            </>
                            <DateRangePicker
                                className="ph-news-date-range"
                                endYear={maxYear}
                                helperText=""
                                // label="Date Range (MM/DD/YYYY)"
                                placeholder="MM/DD/YYYY - MM/DD/YYYY"
                                selectedDateRange={dateRange}
                                size="medium"
                                startYear={minYear}
                                style={{}}
                                datePickerMenu={datePickerMenu}
                                onSelectDateRange = {onDateChange}
                            />
                        </Col>
                    </Row>
                    <Row justify="end">
                            <button className="reset-button" onClick={onFiltersReset}  style={{ marginTop: '12px', marginRight:'0.8rem' }}>
                                <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
                                <span>Reset Filters</span>
                            </button>
                    </Row>            
                    <div className="commodity-detail-header" style={{fontSize: "18px", marginTop:"24px", marginBottom: "8px", lineHeight: "56px", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                        <span>Latest News</span>
                        <Switcher
                            className=""
                            items={[
                                {
                                label: 'All articles',
                                leadingIcon: 'library_books'
                                },
                                {
                                label: 'Saved articles',
                                leadingIcon: 'bookmark_border'
                                },
                            ]}
                            selectedItemIndex={switcherIndex}
                            onUpdate= {(val) => {
                                switchTabs(val)
                            }}
                            style={{}}
                        />
                    </div>

                    <Row justify={"start"} style={{ width: "100%" }}>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Card style={{ height: '100%', padding: "48px" }}>
                                {
                                    (isDataLoading || (Number(localStorage.getItem('ph_news_current_switch'))===0 && allNewsData.type !== "SUCCESS_ALL_NEWS_LIST_ACTION")
                                    && (Number(localStorage.getItem('ph_news_current_switch'))===1 && bookmarkListData.type !== "SUCCESS_BOOKMARK_LIST_ACTION")) ? 
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                                        <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                                    </div>
                                    :
                                    <>
                                        {
                                            switcherIndex === 0 &&
                                            <>
                                                {
                                                    allNewsData?.newsContent && allNewsData?.newsContent?.length>0?
                                                    <>
                                                        {allNewsData?.newsContent.map((item) => (
                                                            <NewsCard key={item.id} card={item} bookmark={bookmarkNews} currentFilters={currentFiltersSaved} onShare={shareNews}/>
                                                        ))}

                                                        <AdvancedPagination
                                                            className="ph-news-pagination"
                                                            currentPage={allListCurrentPage}
                                                            flexWrap="noWrap"
                                                            onPageChange={onAllPageChange}
                                                            rowsPerPageDefaultValue={10}
                                                            showRowsPerPage={false}
                                                            style={{}}
                                                            totalPages={allNewsPageCount}
                                                        />
                                                    </>: 
                                                    <NoData/>   
                                                } 
                                            </>

                                        }

                                        
                                        {
                                            switcherIndex === 1 &&
                                            <>
                                            {
                                                (isDataLoading || (bookmarkListData.type !== "SUCCESS_BOOKMARK_LIST_ACTION")) ? 
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                                                        <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                                                    </div>
                                                :
                                                <>
                                                {
                                                    currentBookmarkPageRows && currentBookmarkPageRows?.length>0?
                                                    <>
                                                        {
                                                            currentBookmarkPageRows?.map((item) => (
                                                                <NewsCard key={item.id} card={item} bookmark={bookmarkNews} currentFilters={currentFiltersSaved} onShare={shareNews}/>
                                                            ))
                                                        }


                                                        <AdvancedPagination
                                                            className="ph-news-pagination"
                                                            currentPage={bookmarkListCurrentPage}
                                                            flexWrap="noWrap"
                                                            onPageChange={onBookmarkPageChange}
                                                            rowsPerPageDefaultValue={10}
                                                            showRowsPerPage={false}
                                                            style={{}}
                                                            totalPages={bookmarkedNewsPageCount}
                                                        />
                                                    </>
                                                    :
                                                    <>
                                                        <EmptyStateV2
                                                            className=""
                                                            description="You haven't bookmarked any articles yet"
                                                            icon="bookmark_border"
                                                            style={{}}
                                                            titleContent="No article bookmarked"
                                                            />
                                                    </>

                                                }
                                                </>
                                            }   
                                            </>

                                    }
                                    </>
                                }
                            </Card>  
                        </Col>
                    </Row>

                    
                    <br/>


                    <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                        {allNewsData?.appOwner?.length > 0 &&
                            <div style={{width: '100%'}}>Please reach out to {allNewsData?.appOwner?.map((contact, index) => (
                                <React.Fragment key={index}>
                                    <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                    {/* {index < allNewsData?.appOwner.length - 1 && ', '} */}
                                    <>
                                        { contact.emailId.includes('enrico') && ' (Fastmarkets RISI), '}
                                        { contact.emailId.includes('niteesh') && ' (SmartCube), '}
                                        { contact.emailId.includes('bhupender') && ' (SmartCube) '}
                                    </>
                                </React.Fragment>
                            ))} for any query on the data displayed.</div>
                        }
                        <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                    </div>

                    <ShareNewsModal
                        visible={showShareModal}
                        onClose={() => setShowShareModal(false)}
                        newsItem={shareModalNewsItem}
                        userEmail={userInfoRef.current?.email}
                    />

                    <SectorDefinitionsModal showModal={showSmartCubeDetailsModal} onCloseModal={() => setShowSmartCubeDetailsModal(false)} />

                    
                </>
		)
	}
}

export default NewsOverview;